<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>计划管理</el-breadcrumb-item>
			<el-breadcrumb-item>码包管理</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-row>
				<el-col :span="18">
					<el-form :inline="true">
						<el-form-item label="查询">
							<el-input v-model="queryKey" placeholder="搜索码包" maxlength="150">
								<i slot="prefix" class="el-input__icon el-icon-search"></i>
							</el-input>
						</el-form-item>

						<el-form-item>
							<el-button type="info" v-on:click="search">查询</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="6" style="text-align:right;">
					<div>
						<el-button type="primary" v-on:click="selectFile">导入码包</el-button>
						<input ref="filElem" type="file" class="upload-file" @change="readTextplain" accept=".txt" />
					</div>
				</el-col>
			</el-row>
		</div>

		<el-table border v-loading="tableLoading" :data="tableData" v-on:filter-change="filterChange">
			<el-table-column type="index" label="序号" width="50"></el-table-column>
			<el-table-column prop="name" label="码包名称" width="280"></el-table-column>
			<el-table-column label="码包状态" column-key="status" prop="status" width="100" :filters="statusFilter" filter-placement="bottom-end">
				<template slot-scope="scope">
					<span slot="reference" style="text-align:left">
						<el-tag size="medium" :type="getStatusTagType(scope.row.status)" v-text="getStatusName(scope.row.status)"></el-tag>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="生产设备" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div class="jtSetting">
						<div class="btn">
							<!-- <el-tooltip class="item" effect="dark" content="点击编辑机台设备"  placement="top"> -->
							<el-button type="info" icon="el-icon-plus" size="mini" @click="setDevice(scope.row)" circle></el-button>
							<!-- </el-tooltip> -->
						</div>
						<div class="items">
							<div v-if="scope.row.jt_ids.length == 0" style="color:#aaa;">暂无</div>
							<div v-else>
								<el-tag :key="tag" type="danger" v-for="tag in scope.row.jt_ids" closable :disable-transitions="false" effect="plain" @close="handleRemoveJT(scope.row, tag)">{{ getJtName(tag) }}</el-tag>
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="product_name" label="产品" width="200"></el-table-column>
			<el-table-column label="操作" width="250" fixed="right">
				<template slot-scope="scope">
					<el-button type="text" @click="showTeachGroupDialog(scope.row)" icon="el-icon-view">查看码信息</el-button>
					<!-- <el-button type="text" @click="deleteGroupDialog(scope.row)" icon="el-icon-delete">删除</el-button> -->
					<el-popconfirm title="确定删除吗？" @onConfirm="deleteGroupDialog(scope.row)">
						<el-button type="text" icon="el-icon-delete" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>

		<!--查看码信息-->
		<el-dialog title="码信息" :visible.sync="codeListVisible" width="800px">
			<div style="margin-bottom:10px; padding-bottom:10px;">
				<el-form :inline="true">
					<el-form-item label="码包名称">
						<el-input v-model="nowPackageName" placeholder="输入码包名称">
							<!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
						</el-input>
					</el-form-item>

					<el-form-item>
						<el-button v-on:click="editName">修改名称</el-button>
					</el-form-item>
				</el-form>
			</div>
			<Codelist v-bind:code-package-id="selectedCodePackageId" />
		</el-dialog>
		<!--选择产品-->
		<ProductSelectDialog :show="productSelectDialogVisible" v-on:close="productSelectDialogClose" v-on:select="selectProduct" />
		<!--设置机台-->
		<DeviceSelectDialog :show="deviceSelectDialogVisible" ref="mychild" :checkedValues="selectedDeviceIds" v-on:setDevice="setPackageDevice" @close="deviceSelectDialogClose" />
	</div>
</template>

<script>
	import * as codePackRequest from '@/network/requests/codePack'
	import NProgress from 'nprogress'
	import ProductSelectDialog from '../public/ProductSelectDialog'
	import DeviceSelectDialog from '../public/DeviceSelectDialog'
	import Codelist from './CodeList'
	import { jtInfoRequest } from '@/network/requests/jtInfo'
	export default {
		components: {
			ProductSelectDialog,
			DeviceSelectDialog,
			Codelist,
		},
		data() {
			this.statusFilter = [
				{ text: '导入', value: 0, color: 'info' },
				{ text: '激活', value: 1, color: 'success' },
				{ text: '失效', value: 2, color: 'danger' },
			]
			return {
				badgeWidth: document.body.clientWidth * 0.5,
				queryKey: '',
				tableData: [],
				tableLoading: false,
				pageSize: 10,
				pageIndex: 1,
				pageCount: 0,
				filterStatus: [0, 1, 2],
				productSelectDialogVisible: false,
				importPackageLines: [],
				importPackageFileName: '',
				selectedCodePackageId: '',
				codeListVisible: false,
				deviceSelectDialogVisible: false,
				selectedDeviceIds: [],
				jtList: [],
				nowPackageName: '',
			}
		},
		computed: {},
		methods: {
			/**
			 * 选择文件。
			 */
			selectFile() {
				this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
			},
			/**
			 * 读取文本文件内容。
			 */
			readTextplain() {
				const inputFile = this.$refs.filElem.files[0]
				var self = this
				if (inputFile) {
					this.importPackageFileName = inputFile.name
					if (window.FileReader) {
						var reader = new FileReader()
						reader.onload = function() {
							if (this.result) {
								//提取换行并过滤掉空内容。
								var lines = this.result
									.replace('\r', '')
									.split('\n')
									.filter(t => t.length > 0)

								self.importPackageLines = lines

								//显示产品选择。
								self.productSelectDialogVisible = true
							} else {
								self.$message.error('文件为空，无法导入。')
							}

							//清空文件选择框的值。
							self.$refs.filElem.value = ''
						}

						reader.readAsText(inputFile)
					} else {
						console.error('不支持该浏览器进行文本内容读取。')
					}
				}
			},
			search() {
				this.pageIndex = 1
				this.query()
			},
			/**
			 * 查询所有码包。
			 */
			query() {
				codePackRequest
					.queryCodePackList(this.pageSize, this.pageIndex, this.queryKey, this.filterStatus)
					.then(({ data }) => {
						this.tableData = data._embedded
						this.pageCount = data._total_pages
					})
					.finally(() => {
						this.tableLoading = false
					})
			},
			/**
			 * 关闭产品选择。
			 */
			productSelectDialogClose() {
				this.productSelectDialogVisible = false
			},
			/**
			 * 选择产品。
			 */
			selectProduct(product) {
				//上传码包，并关联产品。
				codePackRequest.uploadCodePack(this.importPackageFileName, this.importPackageLines, product.id, product.name).then(({ data }) => {
					if (data.inserted > 0) {
						console.log('码包上传完成', data)
					}
					this.productSelectDialogVisible = false
					this.query()
				})
			},
			/**
			 * 获取状态名称。
			 */
			getStatusName(status) {
				var v = this.statusFilter.filter(t => t.value == status)[0].text
				return v
			},
			/**
			 * 获取状态颜色。
			 */
			getStatusTagType(status) {
				return this.statusFilter.filter(t => t.value == status)[0].color
			},
			/**
			 * 查看码包信息。
			 */
			showTeachGroupDialog(row) {
				this.selectedCodePackageId = row._id.$oid
				this.codeListVisible = true
				var result = this.tableData.filter(p => p._id.$oid == row._id.$oid)
				console.log(result)
				if (result) {
					var t = result[0]
					if (t) {
						this.nowPackageName = t.name
					}
				}
			},
			/**
			 * 删除码包
			 */
			deleteGroupDialog(row) {
				codePackRequest
					.deleteCodePack(row._id.$oid)
					.then(res => {
						this.query()
						this.$message({
							type: 'success',
							message: '删除成功',
						})
					})
					.catch(err => {
						this.$message({
							type: 'errror',
							message: '删除异常，请重新尝试' + err.message,
						})
					})
			},
			/**
			 * 修改码包名称。
			 */
			editName() {
				codePackRequest.updateCodeInfo(this.selectedCodePackageId, { name: this.nowPackageName }).then(res => {
					this.$notify({
						title: '成功',
						message: '修改成功',
						type: 'success',
					})

					this.query()
				})
			},
			/**
			 * 查看当前选择的this.$refs.deviceTable.clearSelection()码包名称。
			 */
			getCodePackageName() {
				var result = this.tableData.filter(p => p._id.$oid == this.selectedCodePackageId)
				if (result) {
					var row = result[0]
					if (row) {
						return row.name
					}
				}

				return ''
			},
			/**
			 * 过滤。
			 */
			filterChange(filterInfo) {
				console.log('filterInfo', filterInfo)
				if (filterInfo.status.length == 0) {
					this.filterStatus = [0, 1, 2]
				} else {
					this.filterStatus = filterInfo.status
				}

				this.query()
			},
			/**
			 * 弹出机台设置。
			 */
			setDevice(row) {
				this.selectedDeviceIds = row.jt_ids
				this.selectedCodePackageId = row._id.$oid
				// this.query()
				this.deviceSelectDialogVisible = true
			},
			/**
			 * 设置机台。
			 */
			setPackageDevice(devices) {
				var jt_ids = []
				devices.forEach((v, i) => {
					jt_ids.push(v.id)
				})

				codePackRequest.setJTListOfCodePack(this.selectedCodePackageId, jt_ids).then(res => {
					this.deviceSelectDialogVisible = false
				})

				console.log('设置机台', devices, this.selectedCodePackageId)
			},
			/**
			 * 设备选择弹出框关闭。 this.$refs.deviceTable.clearSelection()
			 */
			deviceSelectDialogClose(rows) {
				// this.$refs.deviceTable.clearSelection()
				this.$refs.mychild.commit()
				this.deviceSelectDialogVisible = false
				this.query()
				// console.log(this.$refs.device)
			},
			/**
			 * 删除机台。
			 */
			handleRemoveJT(row, jt_id) {
				console.log(row, jt_id)

				this.selectedCodePackageId = row._id.$oid
				var jt_ids = []
				row.jt_ids.forEach((v, i) => {
					if (v != jt_id) {
						jt_ids.push(v)
					}
				})

				codePackRequest.setJTListOfCodePack(this.selectedCodePackageId, jt_ids).then(res => {
					this.deviceSelectDialogVisible = false
				})

				row.jt_ids = jt_ids
			},
			/**
			 * 获取机台名称。
			 */
			getJtName(jt_id) {
				var result = this.jtList.find(t => t._id.$oid == jt_id)
				var name = ''
				if (result) {
					name = result.name
				}

				return name
			},
			/**
			 * 切换记录数量。
			 */
			handleSizeChange(pageSize) {
				this.tableLoading = true
				this.pageSize = pageSize
				this.pageIndex = 1
				this.query()
			},
			/**
			 * 页码切换。
			 */
			handleCurrentChange(pageIndex) {
				this.tableLoading = true
				this.pageIndex = pageIndex
				this.query()
			},
		},
		async created() {
			this.tableLoading = true
			this.jtList = await jtInfoRequest.queryAll()
			this.query()
		},
	}
</script>

<style scoped>
	.upload-file {
		display: none;
	}

	.el-tag + .el-tag {
		margin-left: 10px;
	}

	.jtSetting {
		display: flex;
	}

	.jtSetting .btn {
		padding-right: 10px;
		/* width: 40px; */
	}
</style>
